import cloneDeep from 'lodash.clonedeep';
import { emptyObject } from 'ui-components/default-props/empty';
import * as CreateLabelAction from '../../store/create-label-content/create-label-content.actions';
import { baseReducer as BaseReducer } from '../../store/core/base-reducer';

import * as Actions from './rate-browser.actions';

const emptyConfigureRatesModel = {
  shipFromId: '',
  shipToCountryCode: '',
  shipToPostalCode: '',
  weight: {
    weightUnit: 'Ounces',
    weight: 0,
  },
  dimensions: {
    unit: 'Unknown',
  },
  confirmationType: '0',
  serviceClassificationId: '',
  isResidential: false,
};

const initialState = {
  showCreateLabelContent: false,
  configureRatesModel: emptyConfigureRatesModel,
  configureLabelModel: emptyObject,
};

const actionHandlerMap = {
  [Actions.OPEN_RATE_BROWSER_MODAL]: (state, { rateBrowserDefaults }) => {
    const { shipFromId, shipToCountryCode, selectedPackage } = rateBrowserDefaults;
    return {
      ...state,
      configureRatesModel: {
        ...cloneDeep(emptyConfigureRatesModel),
        shipFromId,
        selectedPackage,
        shipToCountryCode,
      },
    };
  },
  [Actions.CLOSE_RATE_BROWSER_MODAL]: () => initialState,
  [Actions.RESET_RATE_BROWSER_MODAL]: () => initialState,
  [Actions.UPDATE_CONFIGURE_RATES_MODEL]: (state, { updatePayload }) => {
    return {
      ...state,
      configureRatesModel: {
        ...state.configureRatesModel,
        ...updatePayload,
      },
      jobGuid: undefined,
    };
  },
  [Actions.UPDATE_RATE_BROWSER_SHIP_FROM_ID]: (state, { shipFromId }) => {
    return {
      ...state,
      configureRatesModel: {
        ...state.configureRatesModel,
        shipFromId,
      },
    };
  },
  [CreateLabelAction.CREATE_LABEL_CONTENT_CONFIGURE_LABEL]: (state) => {
    return {
      ...state,
      showCreateLabelContent: true,
    };
  },
  [Actions.RATE_BROWSER_BACK_TO_RATES]: (state) => {
    return {
      ...state,
      showCreateLabelContent: false,
    };
  },
  [Actions.RATE_BROWSER_SET_MODAL_ID]: (state, { modalId }) => {
    return {
      ...state,
      modalId,
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './rate-browser.reducer.metadata';
